import type { CSSProperties } from "react"

import { Tooltip, type TooltipProps } from "@coval/ui/tooltip"

import { cn } from "@/utils/cn"

import { yesNoBadgeShapeClasses } from "../utils/yesNoBadgeClasses"

/** Values longer than this step down to `text-xs` before truncating. */
const METRIC_VALUE_CHIP_COMPACT_LENGTH = 14

interface MetricValueChipProps {
  value: string
  colorClassName: string
  style?: CSSProperties
  tooltipContentDataAttributes?: TooltipProps["contentDataAttributes"]
}

/**
 * Metric value chip for table cells. Shrinks to its container, steps long
 * values down one text size, then truncates from the end so the start of the
 * value stays readable. The full value shows in a tooltip.
 */
export function MetricValueChip({
  value,
  colorClassName,
  style,
  tooltipContentDataAttributes,
}: MetricValueChipProps) {
  return (
    <Tooltip
      variant="panel"
      content={value}
      contentDataAttributes={tooltipContentDataAttributes}
    >
      <span
        className={cn(
          yesNoBadgeShapeClasses,
          colorClassName,
          "min-w-0 shrink",
          value.length > METRIC_VALUE_CHIP_COMPACT_LENGTH && "text-xs",
        )}
        style={style}
      >
        <span className="min-w-0 truncate">{value}</span>
      </span>
    </Tooltip>
  )
}
